import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAccessToken } from './common';

function PublicRoute({ children }) {
  const token = getAccessToken();
  return !token ? children : <Navigate to="/dashboard" />;
}
 
export default PublicRoute;